export default __webpack_public_path__ + "locales/es/DowngradePlanDialog.json?hash=2b4aeb3495cb0dd67da52ca9e0be38d3";